import { render, staticRenderFns } from "./blogs3.vue?vue&type=template&id=16f106e4&scoped=true"
import script from "./blogs3.vue?vue&type=script&lang=js"
export * from "./blogs3.vue?vue&type=script&lang=js"
import style0 from "./blogs3.vue?vue&type=style&index=0&id=16f106e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f106e4",
  null
  
)

export default component.exports